<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <!-- Users {{$route.params.id}} -->
          <!-- {{resources[0].firstname}} {{resources[0].lastname}} -->
          Enter Credits
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false" :is-full-page="fullPage"></loading>
          <CForm @submit.prevent="addCreditSettings">
            <!-- <h1>Enter Credits</h1> -->
            <p class="text-muted">Enter credits for daily free credit of users</p>
            <CInput
              placeholder="Enter credits"
              type="number"
              v-model="creditSettings.amount"
              :value=0
              style="width: 50%"
            >
              <template #prepend-content><CIcon name="cil-dollar"/></template>
            </CInput>
            <div class="login-errors"  v-if="$v.creditSettings.amount.$error">
              <span class="validation-error" v-if="!$v.creditSettings.amount.required">Please Enter amount</span>
              <span class="validation-error" v-else-if="!$v.creditSettings.amount.maxValue">Please Enter Positive Value</span>
            </div>
            <CRow>
              <CCol col="6" class="text-left">
                <CButton color="primary" class="px-4 mr-2" type="submit">Submit</CButton>
                <CButton color="danger" class="px-4" @click="redirectUrls('/dashboard')">Cancel</CButton>
              </CCol>
              <CCol col="6" class="text-right">
                <!-- <CButton color="link" class="px-0">Forgot password?</CButton> -->
                <!-- <CButton color="link" class="px-0"><a :href="`${APP_URL}login/`">Login</a></CButton> -->
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
  minLength,
  maxValue,
	sameAs
} = require("vuelidate/lib/validators");
const greaterThanZero = (value) => value >= 0
export default {
    name: 'freeCreditSetting',
    data() {
        return {
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            resources: [],
            creditSettings: {
              amount: "",
            },
            APP_URL: APP_URL,
            columns: ['firstname', 'lastname', 'phone'],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: '0',
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              sortable: ['firstname'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              }
            }
        }
    },
    components: {
        Loading
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    components: {
        Loading
    },
    created() {
        document.title = "Free Credit Setting";
        this.loadData();
    },
    methods: {
      loadData() {
        let id = this.$route.params.id
        this.isLoading = true;
        axios.post(`${API_ADMIN_URL}/adminFreeCreditSettings/`, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
          if (response.data.status == 200) {
            this.creditSettings.amount = response.data.data[0].amount;
            this.resources = response.data.data;
            this.isLoading = false;
          }
          else {
              this.isLoading = false;
              localStorage.clear();
              this.$router.push('/login');
          }
          this.isLoading = false;
        });
      },
      addCreditSettings() {
        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        try {
            this.isLoading = true;
          let a =
          axios
          .post(`${API_ADMIN_URL}/adminAddFreeCreditSettings/`, this.creditSettings, {headers: {'x-access-token': this.tokenChange}})
          .then(response => {
            if (response.data.status == 200) {
              this.showSuccessMsg({message: response.data.message});
              this.isLoading = false;
              // this.$router.push("/login");
            }
            else {
              this.isLoading = false;
              this.showErrorMsg({message: response.data.message});
            }
            this.isLoading = false;
          });
        } catch (err) {
          console.log(err);
          this.showErrorMsg({message: 'Something went to wrong, please try again!'});
        }
      },
      redirectUrls: function(link) {
          this.$router.push(link);
          // location.href = link;
      }
    },
    mixins: [validationMixin],
      validations: {
        creditSettings:{
          amount: {
                    required,
                    maxValue: greaterThanZero,
                }
        }
      }
}
</script>
